module.exports = __webpack_public_path__ + "static/oh-snap-da7fc226628a56fae66f7c6de31468ea.png";